// Extraído de `composer-inline-select.vue` e `_base-actions-menu.vue`, que
// reimplementavam a mesma lógica de forma independente: dentro do painel
// flutuante do chat popup, o v-menu nativo do Vuetify não fechava ao clicar
// fora (só fechava selecionando um item), então os dois componentes já
// tinham, cada um, seu próprio listener manual no document em fase de
// captura. O mixin centraliza só o attach/detach do listener — cada
// consumidor decide o que conta como "fora" (`isClickOutside`) e o que fazer
// quando isso acontece (`onClickOutside`), porque essa regra já diverge entre
// os dois: um usa `$el.contains`, o outro também precisa considerar o
// conteúdo teleportado do v-menu.
//
// Contrato do consumidor: `isOpen()`, `isClickOutside(target)`,
// `onClickOutside()`. O listener só fica anexado ao document ENQUANTO
// `isOpen()` é true — `_base-actions-menu.vue` tem 59 call-sites na
// plataforma, então manter o listener sempre ativo (mesmo fechado) escala
// mal; o `$watch` abaixo liga/desliga reativo, sem custo pros que nunca abrem.
export const clickOutsideMixin = {
  mounted() {
    this._clickOutsideUnwatch = this.$watch(
      () => (typeof this.isOpen === 'function' ? this.isOpen() : false),
      (open) => {
        if (open) {
          document.addEventListener('click', this.onDocumentClick, true)
        } else {
          document.removeEventListener('click', this.onDocumentClick, true)
        }
      },
      { immediate: true }
    )
  },
  beforeDestroy() {
    if (this._clickOutsideUnwatch) this._clickOutsideUnwatch()
    document.removeEventListener('click', this.onDocumentClick, true)
  },
  methods: {
    // Guard defensivo: se um consumidor futuro esquecer de implementar
    // isClickOutside/onClickOutside, isso vira um no-op em vez de TypeError
    // em todo clique do app (o listener é global, no document).
    onDocumentClick(event) {
      if (
        typeof this.isClickOutside !== 'function' ||
        typeof this.onClickOutside !== 'function'
      ) {
        return
      }
      if (this.isClickOutside(event.target)) {
        this.onClickOutside()
      }
    },
  },
}
